import styled from '@emotion/styled';

export const Container = styled.div`
    position: relative;
`;

export const StyledButton = styled.button`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    height: 40px;

    padding: ${({ theme }) => theme.spacing[2]};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    background: ${({ theme }) => theme.color.white100};

    line-height: 20px;
    ${({ theme }) => theme.font.text.regular};
    color: ${({ theme }) => theme.color.black200};
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        background: ${({ theme }) => theme.color.white200};
    }
`;

export const Popover = styled.div`
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    z-index: 100;
    padding: ${({ theme }) => theme.spacing[3]};
    border-radius: ${({ theme }) => theme.radius.main};
    box-shadow: ${({ theme }) => theme.shadow.legacy};
    background: ${({ theme }) => theme.color.white100};
`;

export const PresetList = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[1]};
`;

export const PresetItem = styled.button<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
    border: none;
    border-radius: ${({ theme }) => theme.radius.main};
    background: ${({ theme, isSelected }) => (isSelected ? theme.color.grey200 : 'transparent')};
    cursor: pointer;
    ${({ theme }) => theme.font.text.regular};
    color: ${({ theme }) => theme.color.black200};
    font-weight: ${({ theme, isSelected }) => (isSelected ? theme.font.weight.medium : theme.font.weight.regular)};
    text-align: left;

    &:hover {
        background: ${({ theme }) => theme.color.grey200};
    }
`;

export const Separator = styled.hr`
    border: none;
    border-top: 1px solid ${({ theme }) => theme.color.grey200};
    margin: ${({ theme }) => `${theme.spacing[2]} 0`};
`;
